const subAdmin = {
    subAdmin: () => `admin/subadmin`,
    subAdminByID: (id: string) => `admin/subadmin/${id}`,
}
export default subAdmin 